import Cta from './cta'

export default Cta
